import type { ReactNode } from "react";
import { Hint } from "./Hint";

export function CredentialField({
  label,
  hint,
  children,
}: {
  label: string;
  hint: string;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-1.5 text-sm text-secondary">
        <span>{label}</span>
        <Hint title={hint} />
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}
